import { render, staticRenderFns } from "./product_changelly.vue?vue&type=template&id=0f832f7c&scoped=true"
import script from "./product_changelly.vue?vue&type=script&lang=js"
export * from "./product_changelly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f832f7c",
  null
  
)

export default component.exports